import { render, staticRenderFns } from "./dProduct.vue?vue&type=template&id=51a5987e&scoped=true"
import script from "./dProduct.vue?vue&type=script&lang=js"
export * from "./dProduct.vue?vue&type=script&lang=js"
import style0 from "./dProduct.vue?vue&type=style&index=0&id=51a5987e&prod&lang=scss"
import style1 from "./dProduct.vue?vue&type=style&index=1&id=51a5987e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5987e",
  null
  
)

export default component.exports